module.exports = __webpack_public_path__ + "img/1-8.4e2908a3.png";